import { defaultUserSelection } from "@/config/userSelection";
import {
  AGE_END,
  AGE_START,
  BASE,
  BRANDS,
  BUTTERLFY,
  DIFFERENTIATION,
  FILTERS,
  PROFILE_GROUP,
  PROFILE_METRIC,
  GROUPED_BY,
  MARKETS,
  MODE,
  PERCEPTUAL,
  PERIOD,
  PERIOD_END_DATE,
  PERIOD_START_DATE,
  PERIOD_TYPE,
  POINT_IN_TIME,
  POST_END_DATE,
  POST_PERIOD_TYPE,
  POST_START_DATE,
  PROFILE,
  QUESTION_OPTIONS,
  PROFILE_RESPONSE,
  SECONDARY_BRANDS,
  SEGMENTS,
  STAT_TEST,
  VISUALIZATION_TYPE,
  TRENDS_METRIC,
  TRENDS_RESPONSE,
  SCORE_TYPE,
  DEFAULT,
  URL_BY_BRAND,
} from "@/constant/constantsThrougoutProject";
import { ROUTES_CHILDREN_LOOKUP } from "@/routes/routes";
import type { NavigateFunction } from "react-router-dom";

export const getUrlParamsWhileSwitchingPath = (
  pathName: string,
  activeGroupDataIds: any,
  userSelection: any,
) => {
  let currentMode = userSelection?.mode || "POINT_IN_TIME";
  if (
    currentMode === POINT_IN_TIME &&
    pathName === `/emotional/${URL_BY_BRAND}` &&
    (userSelection?.visualizationType === PERCEPTUAL ||
      userSelection?.visualizationType === BUTTERLFY ||
      userSelection?.visualizationType === DIFFERENTIATION ||
      userSelection?.visualizationType === PROFILE)
  ) {
    currentMode = userSelection.visualizationType;
  }
  const finalMapping: any = {};
  const currentPathDetail = ROUTES_CHILDREN_LOOKUP[pathName];
  currentPathDetail?.urlKeysMapping?.[currentMode]?.forEach((key: string) => {
    if (key === MARKETS) {
      let result: any = [];
      if (
        currentPathDetail?.multipleOptionsForKeys[currentMode]?.includes(key)
      ) {
        result =
          userSelection?.[key]?.length > 0
            ? userSelection?.[key]?.filter((id: number) =>
                activeGroupDataIds?.markets?.includes(id),
              )
            : [];
      } else if (userSelection?.[key?.slice(0, -1)]) {
        result = [userSelection?.[key?.slice(0, -1)]];
      }
      if (!result || result?.length === 0) {
        result = activeGroupDataIds?.[key];
      }
      finalMapping[key] = result;
    } else if (key === BRANDS) {
      let result: any = [];
      if (
        currentPathDetail?.multipleOptionsForKeys[currentMode]?.includes(key)
      ) {
        result = userSelection?.[key]?.length > 0 ? userSelection?.[key] : [];
      } else if (currentMode === DIFFERENTIATION || currentMode === BUTTERLFY) {
        if (currentMode === DIFFERENTIATION) {
          result = userSelection?.brands?.slice(0, 1);
          finalMapping["secondaryBrands"] = userSelection?.brands?.slice(1);
        } else if (currentMode === BUTTERLFY) {
          result = userSelection?.brands?.slice(0, 1);
          finalMapping["secondaryBrands"] = userSelection?.brands?.slice(1, 2);
        }
      } else if (userSelection?.[key?.slice(0, -1)]) {
        result = [userSelection?.[key?.slice(0, -1)]];
      }
      if (!result || result?.length === 0) {
        result = activeGroupDataIds?.[key];
      }
      finalMapping[key] = result;
    } else if (key === QUESTION_OPTIONS) {
      const result: string[] = [];
      Object.keys(userSelection[key] || {})?.forEach((value) => {
        const currValue = userSelection?.[key]?.[value];
        currValue?.forEach((item: any) => {
          result.push(`${value}-${item}`);
        });
      });
      finalMapping[key] = result;
    } else if (
      key === PERIOD_START_DATE ||
      key === PERIOD_END_DATE ||
      key === POST_START_DATE ||
      key === POST_END_DATE
    ) {
      finalMapping[key] = userSelection?.[key];
    } else if (key === AGE_START && userSelection?.ageRange?.length > 1) {
      finalMapping[AGE_START] = userSelection?.ageRange[0];
      finalMapping[AGE_END] = userSelection?.ageRange[1];
    } else if (key === SEGMENTS) {
      if (currentPathDetail?.useSegmentSelect) {
        let result: any = activeGroupDataIds?.activeSegments;
        finalMapping[key] = result;
      } else {
        let result: any = userSelection[key];
        if (result && result?.length > 0) {
          finalMapping[key] = result;
        }
      }
    } else if (key === FILTERS) {
      let result: any = userSelection[key];

      if (result && result?.length > 0) {
        finalMapping[key] = result;
      }
    } else if (
      key === STAT_TEST ||
      key === BASE ||
      key === MODE ||
      key === PERIOD_TYPE ||
      key === PERIOD ||
      key === POST_PERIOD_TYPE ||
      // key === METRIC ||
      // key === RESPONSE ||
      key === GROUPED_BY ||
      key === SCORE_TYPE ||
      key === TRENDS_METRIC ||
      key === TRENDS_RESPONSE ||
      key === PROFILE_GROUP ||
      key === PROFILE_METRIC ||
      key === PROFILE_RESPONSE
    ) {
      let result: string = userSelection[key];

      if (result?.length === 0) {
        result = defaultUserSelection[key];
      }
      finalMapping[key] = result;
    } else if (key === VISUALIZATION_TYPE) {
      let result: string = userSelection[key];
      if (pathName !== `/emotional/${URL_BY_BRAND}`) {
        if (
          result === BUTTERLFY ||
          result === PERCEPTUAL ||
          result === DIFFERENTIATION
        ) {
        } else {
          finalMapping[key] = result;
        }
      } else {
        if (result?.length > 0) {
          finalMapping[key] = result;
        }
      }
    }
  });
  return finalMapping;
};

export const buildNewURLQueryString = (
  result: Record<string, any>,
  mode: any = "POINT_IN_TIME",
  pathName?: any,
): URLSearchParams => {
  const updatedURL = new URLSearchParams();
  const currentPathDetail =
    ROUTES_CHILDREN_LOOKUP[pathName ? pathName : location.pathname];

  if (
    location.pathname === `/emotional/${URL_BY_BRAND}` &&
    mode === POINT_IN_TIME &&
    (result?.visualizationType === PERCEPTUAL ||
      result?.visualizationType === BUTTERLFY ||
      result?.visualizationType === DIFFERENTIATION)
  ) {
    mode = result.visualizationType;
  } else if (
    (location.pathname?.startsWith("/emotional") ||
      location.pathname?.startsWith("/advertising") ||
      location.pathname?.startsWith("/equity") ||
      location.pathname?.startsWith("/conversion") ||
      location.pathname?.startsWith("/visibility") ||
      location.pathname?.startsWith("/reputation")) &&
    mode === POINT_IN_TIME &&
    result?.visualizationType === PROFILE
  ) {
    mode = result.visualizationType;
  }

  currentPathDetail?.urlKeysMapping?.[mode]?.forEach((key: string) => {
    if (currentPathDetail?.multipleOptionsForKeys[mode]?.includes(key)) {
      let value = result[key]?.length > 0 ? result[key] : [];
      value = Array.isArray(value) ? value : [value];
      if (value?.length > 0) {
        value && value?.forEach((val: string) => updatedURL.append(key, val));
      }
    } else {
      if (typeof result[key] !== "string" && result[key]?.length > 0) {
        updatedURL.set(key, result[key][0]);
      } else if (typeof result[key] === "number" && result[key] > 0) {
        updatedURL.set(key, result[String(key)]);
      } else if (result[key]?.length > 0) {
        updatedURL.set(key, result[key]);
      }
    }
  });
  return updatedURL;
};

export const buildNewURLQueryStringFromReduxState = (
  result: Record<string, any>,
  mode: any = "POINT_IN_TIME",
  pathName?: any,
): URLSearchParams => {
  const updatedURL = new URLSearchParams();
  const currentPathDetail =
    ROUTES_CHILDREN_LOOKUP[pathName ? pathName : location.pathname];

  if (
    location.pathname === `/emotional/${URL_BY_BRAND}` &&
    mode === POINT_IN_TIME &&
    (result?.visualizationType === PERCEPTUAL ||
      result?.visualizationType === BUTTERLFY ||
      result?.visualizationType === DIFFERENTIATION)
  ) {
    mode = result.visualizationType;
  } else if (
    (location.pathname?.startsWith("/emotional") ||
      location.pathname?.startsWith("/advertising") ||
      location.pathname?.startsWith("/equity") ||
      location.pathname?.startsWith("/conversion") ||
      location.pathname?.startsWith("/visibility") ||
      location.pathname?.startsWith("/reputation")) &&
    mode === POINT_IN_TIME &&
    result?.visualizationType === PROFILE
  ) {
    mode = result.visualizationType;
  }

  currentPathDetail?.urlKeysMapping?.[mode]?.forEach((key: string) => {
    if (key === "questionOptions") {
      let questions: string[] = [];
      Object.keys(result[key] || {})?.map((questionKey: string) => {
        const currentValue = result[key]?.[questionKey];
        currentValue?.forEach((val: number) => {
          questions?.push(`${questionKey}-${val}`);
        });
      });
      questions?.forEach((q: string) =>
        updatedURL?.append("questionOptions", q),
      );
    } else if (currentPathDetail?.multipleOptionsForKeys[mode]?.includes(key)) {
      const value = result[key]?.length > 0 ? result[key] : [];
      if (value?.length > 0) {
        value.forEach((val: string) => updatedURL.append(key, val));
      }
    } else {
      if (typeof result[key] !== "string" && result[key]?.length > 0) {
        updatedURL.append(key, result[key][0]);
      } else if (typeof result[key] === "number" && result[key] > 0) {
        updatedURL.append(key, result[String(key)]);
      } else if (result[key]?.length > 0) {
        updatedURL.append(key, result[key]);
      }
    }
  });
  return updatedURL;
};

/**
 * Constructs a URL from a base, a path, and optional query parameters.
 *
 * @param base The base URL or path segment.
 * @param path The path segment to append.
 * @param params Optional query parameters. `null` and `undefined` values are excluded.
 * @returns The fully constructed URL.
 */
export const buildUrl = (
  base: string,
  path: string,
  params?: Record<
    string,
    string | number | boolean | (string | number)[] | null | undefined
  >,
): string => {
  const combinedPath = `${base.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;

  if (!params || Object.keys(params).length === 0) {
    return combinedPath;
  }

  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== null && value !== undefined) {
      searchParams.append(key, String(value));
    }
  }

  const queryString = searchParams.toString();
  return queryString ? `${combinedPath}?${queryString}` : combinedPath;
};

/**
 * Parse URL search params and convert them to the correct data types
 */
export const parseURLParams = (
  searchParams: URLSearchParams,
): Record<string, string | number | string[] | number[]> => {
  const result: Record<string, string | number | string[] | number[]> = {};
  for (const [key] of searchParams.entries()) {
    if (key === QUESTION_OPTIONS) {
      result[key] = searchParams.getAll(key);
    } else if (
      key === BRANDS ||
      key === FILTERS ||
      key === MARKETS ||
      key === SEGMENTS ||
      key === QUESTION_OPTIONS ||
      key === SECONDARY_BRANDS
    ) {
      result[key] = searchParams.getAll(key).map((val) => Number(val));
    } else {
      result[key] = searchParams.get(key) as string;
    }
  }
  return result;
};

/**
 * Update URL without triggering navigation
 */
export const updateUrlParams = (
  newParams: Record<string, string | number | string[] | number[] | any>,
  navigate: NavigateFunction,
): void => {
  const currentPathDetail = ROUTES_CHILDREN_LOOKUP[location.pathname];
  const currentParams = new URLSearchParams(location.search);
  const result: Record<string, any> = {};
  const currentViz =
    newParams?.visualizationType || currentParams?.get("visualizationType");
  let currentMode: string =
    (newParams["mode"] as any) || currentParams?.get("mode") || "POINT_IN_TIME";
  if (
    location.pathname === `/emotional/${URL_BY_BRAND}` &&
    currentMode === POINT_IN_TIME &&
    (currentViz === BUTTERLFY ||
      currentViz === PERCEPTUAL ||
      currentViz === DIFFERENTIATION)
  ) {
    currentMode = currentViz;
  } else if (
    (location.pathname?.startsWith("/emotional") ||
      location.pathname?.startsWith("/advertising") ||
      location.pathname?.startsWith("/equity") ||
      location.pathname?.startsWith("/conversion") ||
      location.pathname?.startsWith("/visibility") ||
      location.pathname?.startsWith("/reputation")) &&
    currentMode === POINT_IN_TIME &&
    currentViz === PROFILE
  ) {
    currentMode = currentViz;
  }
  for (const key of currentPathDetail?.urlKeysMapping[currentMode]) {
    if (currentPathDetail.multipleOptionsForKeys[currentMode].includes(key)) {
      if (newParams[key]) {
        result[key] = newParams[key];
      } else if (currentParams.getAll(key)) {
        result[key] = currentParams.getAll(key);
      }
    } else {
      if (newParams[key]) {
        result[key] = newParams[key];
      } else if (currentParams.get(key)) {
        result[key] = currentParams.get(key);
      }
    }
  }
  const updatedURL = buildNewURLQueryString(result, currentMode);
  // saveDataToStorageForUserSelection(newParams);
  // Update URL without navigation
  navigate(
    {
      pathname: window.location.pathname,
      search: updatedURL.toString(),
    },
    {
      replace: true,
    },
  );
};
